import {Injectable} from '@angular/core';
import {TranslateProxy} from './translate.proxy';
import {Observable} from 'rxjs';
import {TranslateLoader as NgXTranslateLoader} from '@ngx-translate/core';

/**
	* **********************************************************************
	* Class that implements the interface TranslateLoader for ng2-translate.
	*
	* Written by: Dana Moshe
	* **********************************************************************
	*/
@Injectable()
export class TranslateLoader implements NgXTranslateLoader {
	private cachedTranslations:Observable<Object>;

	constructor(private translateProxy:TranslateProxy) {
	}

	public setCachedTrasnlations(translations:Object){
		this.cachedTranslations=Observable.create(obs=>{obs.next(translations);obs.complete();});
	}
	/**
		* Return observable with the translation by language.
		*
		* @param lang language key.
		* @returns HttpObservable<Object>
		*/
	public getTranslation(lang:string):Observable<Object> {
		// used when the system is working in the external forms mode and the translations
		// are pre-populated
		return this.cachedTranslations || this.translateProxy.getTranslation(lang);
	}
}
